import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const MpgConfirmDialog = ({ title, content, open, setOpen, extraLogicHandlerOnAgree }) => {

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    };

    const callExtraLogicHandlerOnAgree = () => {
        if (!!extraLogicHandlerOnAgree) {
            extraLogicHandlerOnAgree()
        }
        handleClose()
    }

    let dialogContent = ""
    if (content?.includes("\n")) {
        dialogContent = content.split('\n').map(str => <p>{str}</p>);
    } else {
        dialogContent = content
    }


    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {!!title ? title : "Confirm your action...!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {!!dialogContent ? dialogContent : "Are you sure you want to proceed with this action ?"}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>

                    <Button onClick={() => {
                        callExtraLogicHandlerOnAgree()
                    }}
                        autoFocus
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default MpgConfirmDialog